import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignIsLoadingReducer = (state: DesignState, action: PayloadAction<boolean>) => {
  state.isLoading = action.payload;
};

export default setDesignIsLoadingReducer;
